import useAppStore from '@views/app.store.ts'
import { nanoid } from 'nanoid'

export default function customEmoji(editor) {
  const appStore = useAppStore()
  const id = `emoji-${nanoid()}`

  function insertEmoji(img) {
    editor.insertContent(
      `<span contenteditable="false" data-emoji="${img.alt}" class="cus-emoji-img" style="background-image: url(${img.src});">&nbsp;</span>`,
    )
  }
  let htmlstr = ''
  appStore.xhsExpressionList.forEach(item => {
    htmlstr += `<img src="${item.image}" title="${item.title}" alt="${item.textinput}" class="emoji-item" />`
  })
  // htmlstr = divEle.innerHTML
  // 添加表情按钮
  editor.ui.registry.addButton('customEmoji', {
    icon: 'emoji',
    tooltip: '插入表情',
    onAction: () => {
      // 创建表情选择面板
      const panel = editor.windowManager.open({
        title: '选择表情',
        body: {
          type: 'panel',
          items: [
            {
              type: 'htmlpanel',
              html: `<div class="cus-emoji-container" id="${id}">${htmlstr}</div>`,
            },
          ],
        },
        buttons: [
          {
            type: 'cancel',
            text: '关闭',
          },
        ],
      })
      document.querySelectorAll(`#${id} .emoji-item`).forEach(item => {
        // eslint-disable-next-line no-param-reassign
        item.onclick = e => {
          if (e.target.tagName === 'IMG') {
            insertEmoji(e.target)
            panel.close()
          }
        }
      })
    },
  })
}
